<template>
  <div class="hostelhistory-container">
    <template v-for="i in searchInput">
      <el-input
        :key="i.model"
        v-model="search[i.model]"
        style="width: 200px; margin-right: 10px"
        :placeholder="i.label"
        size="small"
      ></el-input>
    </template>
    <el-date-picker
      v-model="search.date"
      type="daterange"
      :clearable="false"
      range-separator="-"
      :start-placeholder="$t('app.checkOutSearchStartTime')"
      :end-placeholder="$t('app.checkOutSearchEndTime')"
      size="small"
      style="margin-right: 10px"
    >
    </el-date-picker>
    <el-button type="primary" @click="reset" size="small">{{
      $t("app.reset")
    }}</el-button>
    <el-button
      type="success"
      @click="getList"
      icon="el-icon-search"
      size="small"
      >{{ $t("app.search") }}</el-button
    >
    <div class="table-container">
      <el-table
        :data="tableData"
        height="620"
        style="width: 100%; color: black"
        @sort-change="sortChange"
      >
        <template v-for="col in column">
          <el-table-column
            v-if="
              col.model === 'roomName' ||
              col.model === 'checkOutTime' ||
              col.model === 'studentNumber'
            "
            :key="col.model"
            align="center"
            :label="col.label"
            :prop="col.model"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            v-else
            :key="col.model"
            align="center"
            :label="col.label"
            :prop="col.model"
          >
          </el-table-column>
        </template>
      </el-table>
    </div>
    <el-pagination
      style="text-align: center; margin-top: 20px"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="total, sizes, prev, pager, next"
    >
    </el-pagination>
  </div>
</template>

<script>
import { getList } from "@/api/dormitoryManagement/hostelCheckOutHistory";
import { delEmpty } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      auto: false,
      time: "",
      loading: false,
      searchInput: [
        { model: "studentNumber", label: this.$t("app.studentNumber") },
        { model: "room", label: this.$t("app.roomCode") },
      ],
      column: [
        { model: "studentNumber", label: this.$t("app.studentNumber") },
        { model: "englishName", label: this.$t("app.nameEnglish") },
        { model: "chineseName", label: this.$t("app.nameChina") },
        {
          model: "roomName",
          label: this.$t("app.roomCode"),
        },
        {
          model: "checkOutTime",
          label: this.$t("app.realCheckOutTime"),
        },
      ],
      search: {
        room: "",
        studentNumber: "",
        name: "",
        date: [],
        orderKey: "",
        orderType: "",
      },
      size: 10,
      currentPage: 1,
      total: 100,
      tableData: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      getList(
        delEmpty({
          RoomIndex: this.search.room,
          StudentName: this.search.name,
          StudentCode: this.search.studentNumber,
          CheckoutDateSearchBegin: this.search.date[0] || "",
          CheckoutDateSearchEnd: this.search.date[1] || "",
          PageIndex: this.currentPage,
          PageSize: this.size,
          OrderKey: this.search.orderKey,
          OrderType: this.search.orderType,
        })
      ).then((res) => {
        this.total = res.data.Total;
        if (res.data.Items == null) {
          this.tableData = [];
          this.total = 0;
          return;
        }

        this.tableData = res.data.Items.map((item) => {
          return {
            studentNumber: item.StudentCode,
            englishName: item.FullName,
            chineseName: item.ChineseName,
            roomName: item.RoomIndex,
            checkOutTime: item.CheckOutDate,
          };
        });
      });
    },
    reset() {
      this.search.room = "";
      this.search.studentNumber = "";
      this.search.date = [];
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    sortChange(obj) {
      this.search.orderKey = obj.prop;
      this.search.orderType = obj.order;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.hostelhistory-container {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
  height: calc(100% - 100px);
  .table-container {
    height: calc(100% - 150px);
    overflow: auto;
  }
}
</style>
